import { useEffect } from "react";
import { Link } from "react-router-dom";
import "@/App.css";

export default function PrivacyPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="legal-page" data-testid="privacy-page">
      <div className="legal-header">
        <Link to="/" className="legal-back" data-testid="privacy-back-link">&larr; Back to Pacely</Link>
      </div>

      <h1 className="legal-title">Privacy Policy</h1>
      <p className="legal-updated">Last updated: March 18, 2026</p>

      <div className="legal-content">
        <section>
          <h2>1. Introduction</h2>
          <p>Pacely ("we", "our", "us") respects your privacy and is committed to protecting the personal information you share with us. This Privacy Policy explains what information we collect, how we use it, and your rights regarding that information.</p>
        </section>

        <section>
          <h2>2. Information We Collect</h2>
          <p>We collect the following information when you interact with our Service:</p>
          <ul>
            <li><strong>Email address</strong> — when you join the waitlist or complete our survey</li>
            <li><strong>Survey responses</strong> — your answers to our customer discovery survey, including running habits, preferences, and concerns</li>
          </ul>
          <p>We do not collect payment information, location data, health data, or any other sensitive personal information at this time.</p>
        </section>

        <section>
          <h2>3. How We Use Your Information</h2>
          <p>Your information is used exclusively for:</p>
          <ul>
            <li>Sending you updates about Pacely's development and launch</li>
            <li>Understanding runner needs to improve our product</li>
            <li>Aggregate analysis of survey responses for product decisions</li>
          </ul>
          <p>We will never sell, rent, or trade your personal information to third parties.</p>
        </section>

        <section>
          <h2>4. Data Storage &amp; Security</h2>
          <p>Your data is stored securely in encrypted databases. We implement industry-standard security measures to protect your information from unauthorized access, alteration, or destruction. Access to personal data is restricted to authorized team members only.</p>
        </section>

        <section>
          <h2>5. Data Sharing</h2>
          <p>We do not share your personal information with third parties, except:</p>
          <ul>
            <li>When required by law or legal process</li>
            <li>To protect the rights, safety, or property of Pacely or others</li>
            <li>With service providers who assist in operating our platform (subject to confidentiality agreements)</li>
          </ul>
        </section>

        <section>
          <h2>6. Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li><strong>Access</strong> the personal data we hold about you</li>
            <li><strong>Correct</strong> inaccurate or incomplete data</li>
            <li><strong>Delete</strong> your data from our systems</li>
            <li><strong>Opt out</strong> of receiving communications from us</li>
          </ul>
          <p>To exercise any of these rights, contact us at <strong>pacely.tech@gmail.com</strong>.</p>
        </section>

        <section>
          <h2>7. Cookies</h2>
          <p>Our website does not currently use cookies or tracking technologies. If this changes in the future, we will update this policy and notify you accordingly.</p>
        </section>

        <section>
          <h2>8. Children's Privacy</h2>
          <p>Our Service is not directed at individuals under the age of 13. We do not knowingly collect personal information from children. If you believe we have collected information from a child, please contact us immediately.</p>
        </section>

        <section>
          <h2>9. Changes to This Policy</h2>
          <p>We may update this Privacy Policy from time to time. Changes will be posted on this page with a revised date. We encourage you to review this policy periodically.</p>
        </section>

        <section>
          <h2>10. Contact Us</h2>
          <p>If you have any questions or concerns about this Privacy Policy or your data, please contact us at <strong>pacely.tech@gmail.com</strong>.</p>
        </section>
      </div>

      <div className="legal-footer">
        <p>&copy; 2026 Pacely. All rights reserved.</p>
        <div className="legal-footer-links">
          <Link to="/terms">Terms of Service</Link>
          <Link to="/">Home</Link>
        </div>
      </div>
    </div>
  );
}
